var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { media } from '../themes/theme';
import { AssistiveTechnologyOnly } from '../../styles/AssistiveTechnologyOnly';
const Nav = styled.nav `
  position: relative;
  display: inline-flex;

  ::after {
    background: ${props => props.theme.MediumGray};
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0.125rem;

    ${media.laptop `
      content: '';
    `}
  }
`;
const NavList = styled.ul `
  display: flex;
  flex-direction: column;
  align-items: center;

  > *:last-child a {
    margin-bottom: 0;
  }

  ${media.laptop `
    display: inline-flex;
    flex-direction: row;

    > *:last-child {
      margin-right: 0;
    }
  `}
`;
const NavItem = styled.li `
  list-style: none;

  ${media.laptop `
    margin-right: 2.5rem;
  `}
`;
const NavLinkCss = css `
  color: ${props => props.theme.White};
  text-decoration: none;
  position: relative;
  margin-bottom: 1rem;
  display: inline-block;
  font-size: 1rem;

  ::after {
    content: '';
    z-index: 2;
    display: ${props => (props.isActive ? 'block' : 'none')};
    background: ${props => props.theme.BrandPrimary};
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.125rem;
  }

  ${media.laptop `
    padding-bottom: 0.625rem;
    margin-bottom: 0;
    font-size: .875rem;
  `}
`;
const NavLinkExternalInner = styled((_a) => {
    var { isActive } = _a, rest = __rest(_a, ["isActive"]);
    return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React.createElement("a", Object.assign({}, rest)));
}) `
  ${NavLinkCss}
`;
export function FooterMetaNavigationLinkExternal({ children, href, className, isActive = false, dataTestId = undefined, }) {
    return (React.createElement(NavLinkExternalInner, { href: href, className: className, isActive: isActive, "data-testid": dataTestId, target: "_blank", rel: "noopener noreferrer" }, children));
}
const VisuallyHiddenLabel = styled.h2 `
  ${AssistiveTechnologyOnly}
`;
const ID_META_NAVIGATION_FOOTER_LABEL = 'meta-navigation-footer-label';
export function FooterMetaNavigation({ className, children, dataTestId = undefined, }) {
    const { t } = useTranslation('Footer');
    return (React.createElement(Nav, { "aria-labelledby": ID_META_NAVIGATION_FOOTER_LABEL, "data-testid": dataTestId, className: className },
        React.createElement(VisuallyHiddenLabel, { id: ID_META_NAVIGATION_FOOTER_LABEL }, t('MetaNavigationFooterLabel')),
        React.createElement(NavList, null, React.Children.map(children, (child, i) => {
            if (child) {
                return React.createElement(NavItem, { key: i }, child);
            }
        }))));
}
